import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase"; // Make sure Firebase is initialized

// Initialize Firebase Functions
const functions = getFunctions(app);

const functionsService = {
  createInvite(email, inviteType, applicationRole, projectId, projectRole) {
    return this.callFunction("createInvite", {
      email,
      inviteType,
      applicationRole,
      projectId,
      projectRole,
    });
  },

  validateInvite(inviteToken, signupInfo, userId) {
    return this.callFunction("validateInvite", {
      inviteToken,
      signupInfo,
      userId,
    });
  },

  getAllUsers() {
    return this.callFunction("getUsers", {});
  },

  getUsersByRole(role) {
    return this.callFunction("getUsers", {
      role,
    });
  },

  updateUserRole(userId, role) {
    return this.callFunction("updateUserRole", { userId, role });
  },

  resetUserPassword(email) {
    return this.callFunction("resetUserPassword", { email });
  },

  setUserDisabled(userId, disabled) {
    return this.callFunction("setUserDisabled", { userId, disabled });
  },

  deleteUser(userId) {
    return this.callFunction("deleteUser", { userId });
  },

  deleteProject(projectId) {
    return this.callFunction("deleteProject", {
      projectId,
    });
  },

  generatePotentialHazards(projectId, model, temperature = 0.2, top_p = 0.2) {
    return this.callFunction("generatePotentialHazards", {
      projectId,
      model,
      temperature,
      top_p,
    });
  },

  generateHazardConsequences(
    projectId,
    hazardDescription,
    hazardType,
    hazardSource,
    causes,
    model,
    temperature = 0.3,
    top_p = 0.3
  ) {
    return this.callFunction("generateHazardConsequences", {
      projectId,
      hazardDescription,
      hazardType,
      hazardSource,
      causes,
      model,
      temperature,
      top_p,
    });
  },

  generateHazardMitigations(
    projectId,
    hazardDescription,
    hazardType,
    hazardSource,
    causes,
    hazardConsequences,
    model,
    temperature = 0.4,
    top_p = 0.4
  ) {
    return this.callFunction("generateHazardMitigations", {
      projectId,
      hazardDescription,
      hazardType,
      hazardSource,
      causes,
      hazardConsequences,
      model,
      temperature,
      top_p,
    });
  },


generateHazardSafetyRequirement(
  projectId,
  hazardDescription,
  hazardType,
  mitigationType,
  mitigationDescription,
  model,
  temperature = 0.2,
  top_p = 0.3
) {
  return this.callFunction("generateHazardSafetyRequirement", {
    projectId,
    hazardDescription,
    hazardType,
    mitigationType,
    mitigationDescription,
    model,
    temperature,
    top_p,
  });
},

  generateHazardSFAIRP(
    projectId,
    hazardDescription,
    hazardType,
    hazardSource,
    causes,
    hazardConsequences,
    hazardUnmitigatedRisk,
    hazardMitigations,
    hazardRetainedRisk
  ) {
    return this.callFunction("generateHazardSFAIRP", {
      projectId,
      hazardDescription,
      hazardType,
      hazardSource,
      causes,
      hazardConsequences,
      hazardUnmitigatedRisk,
      hazardMitigations,
      hazardRetainedRisk,
    });
  },

  generateProjectContext({ projectId, model, temperature = 0.2, top_p = 0.3 }) {
    return this.callFunction("generateProjectContext", {
      projectId,
      model,
      temperature,
      top_p,
    });
  },

  updateProjectMetadata({ metadata, projectId }) {
    return this.callFunction("updateProjectMetadata", {
      metadata,
      projectId,
    });
  },

  // Generic method to call a Firebase function
  async callFunction(functionName, params) {
    try {
      const callableFunction = httpsCallable(functions, functionName);
      const { data } = await callableFunction(params);
      return data;
    } catch (error) {
      console.error(
        "Error calling Firebase function:",
        error.code,
        error.message
      );
      throw error;
    }
  },
};

export default functionsService;
